const React = require('react');

class FormElement extends React.Component {
    constructor(props) {
        super(props);

        this.props = props;

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        let obj = {};
        obj[event.target.name] = event.target.value;
        this.props.onChange(obj);
    }

    static displayFormat(value, format, currency) {
        if(false === format)
            return value;
        if (format === 'currency') {
            //let decimal = currency === '£' ? 2:0;
            let decimal = 2;
            return currency + FormElement.roundDecimals(value, decimal).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        }

        return FormElement.roundDecimals(value, 3);
    }

    static roundDecimals(value, suffix) {
        return parseFloat(value).toFixed(suffix);
    }

    static getPattern(format) {
        if('currency' === format || 'number' === format) {
            return 'pattern="[0-9]*"';
        }

        return '';
    }

    render() {
        // Hide the element if we got hidden signal
        if(true === this.props.hidden) return null;

        switch(this.props.type) {
            case 'number':
            case 'text':
                let pattern = FormElement.getPattern(this.props.format);
                return (
                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label text-right">{this.props.label}</label>
                        <div className="col-sm-6">
                            <input pattern="[0-9]*" className="form-control" name={this.props.name} type={this.props.type} value={this.props.value} onChange={this.handleChange}/>
                        </div>
                    </div>
                );
            case 'dropdown':
                let options = [];
                let key;
                for (key in this.props.source) {
                    options.push(<option key={key} value={this.props.source[key]}>{key}</option>);
                }

                return (
                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label text-right">{this.props.label}</label>
                        <div className="col-sm-6">
                            <select className="form-control" value={this.props.value} name={this.props.name} onChange={this.handleChange}>
                                {options}
                            </select>
                        </div>
                    </div>
                );
            case 'label':
                let displayFormat = FormElement.displayFormat(this.props.value, this.props.format, this.props.currency);

                return (
                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label text-right">{this.props.label}</label>
                        <div className="col-sm-6 text-left">
                            <span className="form-control-plaintext" id={this.props.name}>{displayFormat}</span>
                        </div>
                    </div>
                );
        }
    }
}

module.exports = FormElement;


// WEBPACK FOOTER //
// ./src/FormElement.js